import React, { useCallback, useState, useEffect, memo, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import '../../../css/components/batches/TrolleyVehicleCard.css';

import * as actions from '../../../redux/actions/batches';
import Traductor from '../../Traductor';
import { getImageSource } from '../../../Functions';

const TrolleyVehicleCard = ({
    car,
    removeCarFromBatch,
    disabled,
    hideSeparator,
    onDelete,
}) => {
    const t = useMemo(() => new Traductor(), []); //to be changed
    const [modelDescription, setModelDescription] = useState('');

    const imageSrc = useMemo(
        () => getImageSource(car.ImageSource),
        /*getImageSource(car.PathImage || car.FilePathComercialPhoto,
                car.Image || car.ImagesPath[0],
                car.ImageHash || car.ImagesHash[0]
            )*/ [
            car.ImageSource,
        ]
    );
    const Brand =
        typeof car.Brand === 'string' ? car.Brand : car.Brand.Description;
    const Model =
        typeof car.ModelLong === 'string'
            ? car.ModelLong
            : car?.Model?.DescriptionLong;

    useEffect(() => {
        if (Model && Brand) {
            let brandModified =
                Brand.charAt(0).toUpperCase() + Brand.toLowerCase().slice(1);
            if (Model.indexOf(brandModified) <= 0) {
                setModelDescription(Model.replace(brandModified, '').trim());
            }
        }
    }, [car, Brand, Model]);

    const onRemoveCarFromBatch = useCallback(
        e => {
            //Stop event propagation in order to keep menu open after remove car click
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            //validation if needed
            onDelete ? onDelete(car) : removeCarFromBatch(car.Id);

            const button = document.getElementById(`trolley-button-${car.Id}`);
            if (button?._tippy) {
                button._tippy.setContent(t.getTraduction('AddToBatch'));
            }
        },
        [car, onDelete, removeCarFromBatch, t]
    );

    return (
        <li className="c-page-head-nav__dropdown-list-item">
            <section
                className="c-media-teaser o-layout u-p-none u-m-none"
                style={{ display: 'flex' }}
            >
                <div
                    className={`c-media-teaser__media u-1/3  ${
                        disabled ? 'c-card--inactive' : ''
                    }`}
                    style={{ flexBasis: 'unset' }}
                >
                    <img
                        className="c-media-teaser__image js-object-fit"
                        src={imageSrc}
                        style={{
                            height: 'auto',
                            maxHeight: '100%',
                            width: 'auto',
                            maxWidth: '100%',
                        }}
                        alt={`${car?.Model?.Description || car.Model}`}
                    />
                </div>
                <div
                    className=" u-2/3 c-media-teaser__caption u-p-none u-pl-small u-pb-none@s"
                    style={{ lineHeight: 'normal' }}
                >
                    <div className={disabled ? 'c-card--inactive' : ''}>
                        <h5 className="c-media-teaser__title u-mb-none u-h5">
                            {Brand +
                                ' ' +
                                (car?.Model?.Description || car.Model) +
                                ' - ' +
                                car.Plate}
                        </h5>
                        <p
                            className="c-media-teaser__body u-h6 u-font-initial u-mb-small u-text-truncate"
                            style={{ textTransform: 'initial' }}
                        >
                            {modelDescription}
                        </p>
                    </div>
                    <div className="u-2/3 c-media-teaser__footer">
                        <button
                            className="c-btn o-inline-group u-p-none u-m-none u-animated-outline-container"
                            onClick={e => onRemoveCarFromBatch(e)}
                        >
                            <i className="c-btn__icon c-icon  c-icon--[bin] c-icon--xxsmall u-mr-xxsmall" />
                            <p className="u-text-brand u-text-fs-2 u-animated-outline-item">
                                {t.getTraduction('Delete')}
                            </p>
                        </button>
                    </div>
                </div>
            </section>
            {disabled && (
                <p
                    className="c-error-message u-mt-small"
                    style={{ lineHeight: 'initial' }}
                >
                    {t.getTraduction('CarBatchUnavailable')}
                </p>
            )}
            {!hideSeparator && <hr className="u-mb-none u-p-none u-mv" />}
        </li>
    );
};

TrolleyVehicleCard.propTypes = {
    car: PropTypes.shape({}),
    removeCarFromBatch: PropTypes.func.isRequired,
    disabled: PropTypes.any,
    hideSeparator: PropTypes.bool,
    onDelete: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(actions, dispatch),
});

export default memo(connect(null, mapDispatchToProps)(TrolleyVehicleCard));
